'use strict';
import React from 'react';
import flux from 'utils/flux';
import store from 'store';
import {Link} from 'react-router';
import _cloneDeep from 'lodash/lang/cloneDeep';
import isEmpty from 'lodash/lang/isEmpty';
import {assign, range} from 'lodash';
import classnames from 'classnames';

var HeaderSorting = React.createClass({
    displayName: 'HeaderFilter',
    contextTypes: {
        router: React.PropTypes.func.isRequired
    },
    shouldComponentUpdate() {
        return !flux.getStore('media').isLoading();
    },
    updateFilter(event) {
        let query = _cloneDeep(this.context.router.getCurrentQuery());
        let sortingKey = event.target.value;
        query.sorting = sortingKey;
        sessionStorage.setItem('sortingKey', sortingKey);
        this.context.router.transitionTo('listing', null, query);
    },
    render() {
        let currentSortingOption = this.context.router.getCurrentQuery().sorting;
        return (
            <div className="headerbar__sorting">
                <select className="btn btn-border" onChange={(e) => this.updateFilter(e)} value={ currentSortingOption ? currentSortingOption : null }>
                    {config.searchSortSettings.map((index) => <option key={index} value={index}>{flux.t(index)}</option>)}
                </select>
            </div>
        );
    }
});

module.exports = HeaderSorting;



// WEBPACK FOOTER //
// ./app/components/headerBar/headerSorting.jsx